import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgFileText = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M23.37 9.006 17.243 2.88a.876.876 0 0 0-.619-.256h-10.5a1.75 1.75 0 0 0-1.75 1.75v19.25a1.75 1.75 0 0 0 1.75 1.75h15.75a1.75 1.75 0 0 0 1.75-1.75v-14a.875.875 0 0 0-.256-.62ZM17.5 5.612l3.138 3.138H17.5V5.612Zm4.375 18.013H6.125V4.375h9.625v5.25a.875.875 0 0 0 .875.875h5.25v13.125Zm-3.5-8.75a.875.875 0 0 1-.875.875h-7a.875.875 0 0 1 0-1.75h7a.875.875 0 0 1 .875.875Zm0 3.5a.875.875 0 0 1-.875.875h-7a.875.875 0 0 1 0-1.75h7a.875.875 0 0 1 .875.875Z" />
  </svg>
);
export default SvgFileText;
